'use client';

// Temporary component for backward compatibility.
// This should be removed once it is safe to use the /api/player request from the SS.
// Do not add extra logic here; it is only for legacy footer rendering.

import Link from 'next/link';
import { Trans, useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/react/shallow';
import type { Country } from '@/helpers/conf';
import { useGetCommonStore } from '@/store';
import { getCopyrightConfig } from './helpers';
import { ScFooterCopyright } from './styled';

interface ISafeFooterCopyright {
  children: React.ReactNode;
  i18nKeyServer: string;
  currentFullYear: number;
  copyrightDomain: string;
  countryCode: Country;
}

export const SafeFooterCopyright = ({
  children,
  currentFullYear,
  copyrightDomain,
  i18nKeyServer,
  countryCode,
}: ISafeFooterCopyright) => {
  const { t } = useTranslation();
  const useCommonStore = useGetCommonStore();

  const { pendingUser } = useCommonStore(
    useShallow((s) => ({
      pendingUser: s.pendingUser,
    }))
  );

  const { i18nKey, links } = getCopyrightConfig(countryCode);

  // If user data is still loading or matches the server key, render children as-is
  if (pendingUser || i18nKey === i18nKeyServer) {
    return children;
  }

  // If there is a mismatch, render the updated footer
  console.warn('Server footer data mismatch!');
  return (
    <ScFooterCopyright>
      <Trans
        components={{
          p: <p />,
          1: <Link href={links.terms} />,
          2: <Link href={links.responsibleGaming} />,
        }}
        i18nKey={i18nKey}
        ns="common"
        t={t}
        values={{ year: currentFullYear, domain: copyrightDomain }}
      />
    </ScFooterCopyright>
  );
};
